import React from 'react';
const logo = require('../assets/instagram.svg');

export function InstagramIconButton(props: React.AnchorHTMLAttributes<any>) {
    return (
        <a {...props} className="button is-white">
            <span className="icon is-small">
                <img src={logo} />
            </span>
        </a>
    );
}
